import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { PlannedMaintenanceDto } from "../models/maintenance/planned-maintenance.dto";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";

@Injectable()
export class PlannedMaintenancesService extends DataService<PlannedMaintenanceDto, PlannedMaintenanceDto> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'planned-maintenances';
    }

    getAgreementPlannedMaintenances(agreementId: number): Observable<PlannedMaintenanceDto[]> {
        return this.getQuery(`${this.baseUrl()}/agreement-planned-maintenances/${agreementId}`);
    }
}